import React from "react";
import { InputJson } from "nq-component";
import {
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import AirportAssignFormPresenter from "./AirportAssignFormPresenter";
import DateRangePicker from "../../../../components/common/DateRangePicker";
import { Space, DatePicker } from "antd";
import FormFactory from "../../../../components/FormFactory";

class AirportAssignForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      startDate: null,
      endDate: null,
    };
    this.presenter = new AirportAssignFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "airport_assign";
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  // async handleFormSubmit() {
  //   console.log("fvff");
  //   const { object } = this.state;

  //   const data = {
  //     date: object?.date,
  //   };

  //   await upsertUseCase().execute("airport_assign", data);
  // }

  render() {
    const { object, advanced, employees } = this.state;
    // const { RangePicker } = DatePicker;

    console.log("object", object);

    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>no schema</h1>;

    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.presenter.submit();
                  }}
                >
                  <div className="">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <div className="row">
                          <div className="col-md-12">
                            <FormFactory
                              schema={schema}
                              object={object}
                              // disabled={true}
                              onChange={this.onChange.bind(this)}
                            />
                          </div>
                          <br></br>
                          {/* <div className="col-md-12 mt-2">
                            <Space direction="vertical" size={20}>
                              <RangePicker
                                onChange={(value) =>
                                  this.presenter.onChangeDate(value)
                                }
                                className="custom-range-picker border p-2 fw-semibold"
                              />
                            </Space>
                          </div> */}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(AirportAssignForm);
